import styles from "../landing-page-four.module.css";

interface PhysicalSectionProps {}

export const PhysicalSection = (props: PhysicalSectionProps) => {
  return (
    <div className={styles.physicalSectionContainer}>
      <div className={styles.physicalContent}>
        <img
          className={styles.physicalImage}
          src="/landing-page/landing-four/physical-example.webp"
          alt="Physical printed map poster"
          loading="lazy"
          width={1250}
          height={956}
        />
        <div className={styles.physicalDescription}>
          <h2 className={styles.physicalTitle}>Premium Quality Prints</h2>
          <div className={styles.physicalDetails}>
            <div className={styles.physicalDetail}>
              <h3 className={styles.physicalDetailTitle}>
                Aluminium Dibond Material
              </h3>
              <p className={styles.physicalDetailText}>
                Lightweight yet rigid aluminium dibond composite panel with
                exceptional durability, vibrant color reproduction, and a
                frameless minimal finish that won't warp or fade
              </p>
            </div>
            <div className={styles.physicalDetail}>
              <h3 className={styles.physicalDetailTitle}>Size Options</h3>
              <ul className={styles.physicalDetailList}>
                <li>8" × 8"</li>
                <li>12" × 8"</li>
                <li>11.7" × 8.3" (A4)</li>
                <li>12" × 12"</li>
                <li>16" × 12"</li>
                <li>16" × 16"</li>
              </ul>
            </div>

            {/* <div className={styles.physicalDetail}>
              <h3 className={styles.physicalDetailTitle}>Finish Options</h3>
              <p className={styles.physicalDetailText}>
                Choose from matte, gloss, or lustre finishes to match your
                aesthetic
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
